module.exports = __webpack_public_path__ + "img/bmw.ac45db52.png";